import kebabCase from "lodash/kebabCase";

/** v2 global “All scenarios” listing (replaces v1 home `/`). */
export const ALL_SCENARIOS_V2_HREF = "/version-2/scenarios/all/";

/** Main category tab order on scenario listing pages. */
const CATEGORY_NAV_ORDER = [
  "Exoplanets",
  "Solar System",
  "Misc",
  "Spaceflight",
  "Starship",
];

/** v2 scenario menu pages (canonical listings). */
export const V2_CATEGORY_MENU_HREF: Record<string, string> = {
  Exoplanets: "/version-2/scenarios/exoplanets/all/",
  "Solar System": "/version-2/scenarios/solar-system/all/",
  Misc: "/version-2/scenarios/what-if/",
  Spaceflight: "/version-2/scenarios/spaceflight/",
};

const V2_CATEGORY_PATH_PREFIX: Record<string, string> = {
  Exoplanets: "/version-2/scenarios/exoplanets",
  "Solar System": "/version-2/scenarios/solar-system",
  Misc: "/version-2/scenarios/what-if",
  Spaceflight: "/version-2/scenarios/spaceflight",
};

export const getCategoryMenuHref = (categoryName: string): string => {
  const v2Href = V2_CATEGORY_MENU_HREF[categoryName];
  if (v2Href) {
    return v2Href;
  }

  return `/${kebabCase(categoryName)}`;
};

export const isCategoryNavItemActive = (
  categoryName: string,
  currentPageName: string,
  pathname: string
): boolean => {
  const v2Prefix = V2_CATEGORY_PATH_PREFIX[categoryName];
  if (v2Prefix && pathname.startsWith(v2Prefix)) {
    return true;
  }

  return kebabCase(currentPageName) === kebabCase(categoryName);
};

export const isV2CategoryMenuLink = (categoryName: string): boolean =>
  categoryName in V2_CATEGORY_MENU_HREF;

export const isAllScenariosNavActive = (pathname: string): boolean =>
  pathname.startsWith("/version-2/scenarios/all");

/** Keep v2-migrated categories in the nav when v1 has no scenarios left. */
export const getCategoryNavGroups = (
  groups: { fieldValue: string }[]
): { fieldValue: string }[] => {
  const byName = new Map(groups.map(group => [group.fieldValue, group]));

  for (const categoryName of Object.keys(V2_CATEGORY_MENU_HREF)) {
    if (!byName.has(categoryName)) {
      byName.set(categoryName, { fieldValue: categoryName });
    }
  }

  const ordered: { fieldValue: string }[] = [];

  for (const categoryName of CATEGORY_NAV_ORDER) {
    const group = byName.get(categoryName);
    if (group) {
      ordered.push(group);
      byName.delete(categoryName);
    }
  }

  for (const group of byName.values()) {
    ordered.push(group);
  }

  return ordered;
};
